module.exports = __webpack_public_path__ + "MDIlogo_notext_white.png?d71b73f49c7ebf5477e51a3287051185";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marathondynamics/MDIlogo_notext_white.png
// module id = 585
// module chunks = 0